import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class MaskScreenService {
  private maskSubject$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  constructor() {
  }

  maskScreen(mask: boolean) {
    this.maskSubject$.next(mask);
  }

  onMaskChange(): Observable<boolean> {
    return this.maskSubject$.asObservable();
  }
}
